import React from 'react';
import { FocusScope } from '@react-aria/focus';
import addMonths from 'date-fns/addMonths';
import startOfMonth from 'date-fns/startOfMonth';
import isSameDay from 'date-fns/isSameDay';
import BaseCalendar from './BaseCalendar/BaseCalendar';
import { DatePickerHead, localeUtilsFactory, CalendarView, } from 'wix-style-react-tpa';
import { st, classes } from './Calendar.st.css';
import { dataHooks } from './constants';
import { ButtonSize } from '../../Button';
class Calendar extends React.PureComponent {
    constructor(props) {
        super(props);
        this._setMonth = (month) => {
            this.setState({ month });
            const { onMonthChange } = this.props;
            if (onMonthChange) {
                onMonthChange(month);
            }
        };
        this._getLocaleUtilsFactory = (locale, firstDayOfWeek) => {
            return localeUtilsFactory(locale, firstDayOfWeek);
        };
        this._createCaptionElement = () => {
            const { showMonthDropdown, showYearDropdown, leftArrowAriaLabel, leftArrowAriaLabelledBy, rightArrowAriaLabel, rightArrowAriaLabelledBy, monthDropdownAriaLabel, monthDropdownAriaLabelledBy, yearDropdownAriaLabel, yearDropdownAriaLabelledBy, size, } = this.props;
            const { month } = this.state;
            const locale = this._getLocale();
            const localeUtils = this._getLocaleUtilsFactory(locale, undefined);
            return (React.createElement(DatePickerHead, { id: undefined,
                className: classes.header,
                date: month,
                showYearDropdown,
                showMonthDropdown,
                locale: typeof locale === 'string' ? locale : '',
                localeUtils,
                onChange: this._setMonth,
                onLeftArrowClick: () => this._setMonth(startOfMonth(addMonths(month, -1))),
                onRightArrowClick: () => this._setMonth(startOfMonth(addMonths(month, 1))),
                leftArrowAriaLabel,
                leftArrowAriaLabelledBy,
                rightArrowAriaLabel,
                rightArrowAriaLabelledBy,
                monthDropdownAriaLabel,
                monthDropdownAriaLabelledBy,
                yearDropdownAriaLabel,
                yearDropdownAriaLabelledBy,
                size }));
        };
        const initialMonth = Calendar.getUpdatedMonth(Calendar.parseValue(props.value), props.numOfMonths, undefined);
        this.state = {
            month: initialMonth || new Date(),
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextValue = Calendar.parseValue(nextProps.value);
        const currentValue = Calendar.parseValue(this.props.value);
        if (nextValue.getTime() !== currentValue.getTime()) {
            const month = Calendar.getUpdatedMonth(nextValue, nextProps.numOfMonths, this.state.month);
            if (month) {
                this.setState({ month });
            }
        }
    }
    static areValuesEqual(value1, value2) {
        if (!value1 && !value2) {
            return true;
        }
        return isSameDay(value1, value2);
    }
    _getLocale() {
        return this.props.locale || this.context.locale || 'en';
    }
    render() {
        const { dataHook, className, autoFocus, numOfMonths, firstDayOfWeek, onChange, onClose, excludePastDates, filterDate, value, shouldCloseOnSelect, locale, rtl, dateIndication, today, size, onKeyDown, containFocus, showOutsideDays, fixedWeeks, } = this.props;
        const { month } = this.state;
        return (React.createElement("div", null,
            React.createElement(FocusScope, { contain: autoFocus && containFocus, restoreFocus: containFocus },
                React.createElement(BaseCalendar, { dataHook: dataHook || dataHooks.baseCalendar, size: size, className: st(classes.root, className), autoFocus: autoFocus, numOfMonths: numOfMonths, firstDayOfWeek: firstDayOfWeek, onChange: onChange, onClose: onClose, excludePastDates: excludePastDates, filterDate: filterDate, value: Calendar.parseValue(value), shouldCloseOnSelect: shouldCloseOnSelect, locale: locale, rtl: rtl, dateIndication: dateIndication, today: today, onDisplayedViewChange: this._setMonth, displayedMonth: month, captionElement: this._createCaptionElement(), onKeyDown: onKeyDown, fixedWeeks: fixedWeeks, showOutsideDays: showOutsideDays }))));
    }
}
Calendar.displayName = 'Calendar';
Calendar.defaultProps = {
    className: '',
    filterDate: () => true,
    dateIndication: () => null,
    shouldCloseOnSelect: true,
    onClose: () => { },
    autoFocus: true,
    excludePastDates: false,
    showMonthDropdown: false,
    showYearDropdown: false,
    numOfMonths: 1,
    size: ButtonSize.medium,
    fixedWeeks: true,
};
// @ts-expect-error
Calendar.optionalParse = BaseCalendar.optionalParse;
/** Return a value in which all string-dates are parsed into Date objects */
Calendar.parseValue = BaseCalendar.parseValue;
Calendar.nextDay = BaseCalendar.nextDay;
Calendar.prevDay = BaseCalendar.prevDay;
Calendar.getUpdatedMonth = (nextPropsValue, numOfMonths, currentMonthDate) => {
    const nextValue = Calendar.parseValue(nextPropsValue);
    if (!currentMonthDate) {
        return nextValue;
    }
    const view = new CalendarView(currentMonthDate, numOfMonths);
    if (!view.isContained(nextValue)) {
        return nextValue;
    }
    /*
     * We only changed the month if the day (or range.edges) are outside the view.
     * This is to avoid changing the month right after a user clicks on the calendar.
     */
    return null;
};
export default Calendar;
//# sourceMappingURL=Calendar.js.map